var scriptURL = 'https://sdks.shopifycdn.com/buy-button/latest/buy-button-storefront.min.js';

export default class ShopifyClient {
    constructor(clientconfig) {
        this.init = this.init.bind(this);
        this.loadScript = this.loadScript.bind(this);
    }
    init() {
        if (window.ShopifyBuy) {
            if (window.ShopifyBuy.UI) {
                this.ShopifyBuyInit();
            } else {
                this.loadScript();
            }
        } else {
            this.loadScript();
        }
    }

    loadScript() {
        var script = document.createElement('script');
        script.async = true;
        script.src = scriptURL;
        (document.getElementsByTagName('head')[0] || document.getElementsByTagName('body')[0]).appendChild(script);
        script.onload = this.ShopifyBuyInit;
    }

  ShopifyBuyInit() {
  }

  initButton(element, productid) {
    this.client = ShopifyBuy.buildClient({
      domain: 'atw-testshop.myshopify.com',
      apiKey: '1d53f59ae9346f7fc0c6a4076dcca89a',
      appId: '6',
    });
    ShopifyBuy.UI.onReady(this.client).then(function (ui) {
      ui.createComponent('product', {
        id: [productid],
        node: element,
        moneyFormat: '%E2%82%AC%7B%7Bamount%7D%7D',
        options: shopifyoptions});
    });
  }

}

const shopifyoptions = {
  "product": {
    "iframe": false,
    "variantId": "all",
    "width": "240px",
    "contents": {
      "img": false,
      "title": false,
      "variantTitle": false,
      "price": false,
      "description": false,
      "buttonWithQuantity": false,
      "quantity": false
    },
    "text": {
      "button": "In den Warenkorb"
    },
    "styles": {
      "product": {
        "text-align": "left",
        "@media (min-width: 601px)": {
          "max-width": "calc(25% - 20px)",
          "margin-left": "20px",
          "margin-bottom": "50px"
        }
      },
      "button": {
        "font-family": "Open Sans, sans-serif",
        "font-weight": "normal"
      }
    },
    "googleFonts": [
      "Open Sans"
    ]
  },
  "cart": {
    "contents": {
      "button": true
    },
    "text": {
      "title": "Warenkorb",
      "total": "Zwischensumme",
      "notice": "",
      "button": "Zur Kasse gehen",
      "empty": "Der Warenkorb ist leer."
    },
    "styles": {
      "button": {
        "font-family": "Open Sans, sans-serif",
        "font-weight": "normal"
      },
      "footer": {
        "background-color": "#ffffff"
      }
    },
    "googleFonts": [
      "Open Sans"
    ]
  },
  "modalProduct": {
    "contents": {
      "variantTitle": false,
      "buttonWithQuantity": true,
      "button": false,
      "quantity": false
    },
    "styles": {
      "product": {
        "@media (min-width: 601px)": {
          "max-width": "100%",
          "margin-left": "0px",
          "margin-bottom": "0px"
        }
      },
      "button": {
        "font-family": "Open Sans, sans-serif",
        "font-weight": "normal"
      }
    },
    "googleFonts": [
      "Open Sans"
    ]
  },
  "toggle": {
    "styles": {
      "toggle": {
        "font-family": "Open Sans, sans-serif",
        "font-weight": "normal"
      }
    },
    "googleFonts": [
      "Open Sans"
    ]
  },
  "productSet": {
    "styles": {
      "products": {
        "@media (min-width: 601px)": {
          "margin-left": "-20px"
        }
      }
    }
  }
};


// WEBPACK FOOTER //
// ./src/shopify.js